import { Injectable } from '@angular/core';
import { DfsGlobalsService } from './../../core/dfs-globals.service';
import map from 'lodash-es/map';
import { NDfs } from '../../dfs.interfaces';

export interface IDfsSimpleParserOptions {
    // whitelist?: string[];
    customCss: {
        // css to apply when value matches
        [value: string]: any;
    };
}
@Injectable({
    providedIn: 'any'
})
export class DfsSimpleParserService implements NDfs.IParser {
    /**
     * Returns the value from string
     */
    parse(dfsGlobalsService: DfsGlobalsService, dfs: string, rule: NDfs.IParserRule): NDfs.ICssEntry[] {
        const custom = rule.parserOptions?.customCss[dfs];
        if (custom) {
            return map(custom, (value, prop) => ({ value, prop }));
        }
        return [
            {
                prop: rule.prop,
                value: dfs
            }
        ];
    }
}
